
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13.2002 7.06998L10.2502 11L12.5002 14C12.8302 14.44 12.7402 15.07 12.3002 15.4C11.8602 15.73 11.2302 15.65 10.9002 15.2C9.85017 13.8 8.59018 12.13 7.80018 11.06C7.40018 10.53 6.60018 10.53 6.20018 11.06L2.20018 16.39C1.71018 17.06 2.18018 18 3.00018 18H21.0002C21.8202 18 22.2902 17.06 21.8002 16.4L14.8002 7.06998C14.4002 6.52998 13.6002 6.52998 13.2002 7.06998Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-terrain`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconTerrain

    ```js
    <b-new-b-icon-terrain />
    ```
</docs>


